var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({class:_vm.mergedClasses},_vm.$listeners),[(_vm.iconComponent)?_c(_vm.iconComponent,{tag:"component",staticClass:"fe-w-full fe-h-full",style:({ cursor: 'inherit' })}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }